<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="8" style="text-align: start">
                <strong>{{$t('components.addCashier')}}</strong>
              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="status_form ==0"  class="mr-1 ml-1"  @click="insert_data(true)"
                         type="submit" size="sm" color="secondary">
                  {{ $t('buttons.submit') }}
                </CButton>
                <CButton v-if="status_form !=0" @click="insert_data(true)"
                         type="submit" size="sm" color="secondary">
                  {{ $t('buttons.edit') }}
                </CButton>
                <CButton
                    class="mr-1"
                    type="reset" size="sm" color="secondary">
                  {{ $t("buttons.print") }}
                </CButton>

              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol col="3">
                <CSelect :options="filtered_accounting_list_add" :label="$t('accountSarfasl')"
                         :value.sync="selected_moein"
                         :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                />
              </CCol>
              <CCol col="3">
                <CInput
                    :label="$t('tables.bankAccTitle')"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                    v-model="name"

                />
              </CCol>
              <CCol sm="3">
                <CRow form class="form-group">
                  <CCol tag="label" sm="5" class="col-form-label">
                    {{$t('components.userName')}}
                  </CCol>
                  <CCol sm="7">
                    <treeselect
                        v-model="document_person"
                        :options="searched_person"

                        :async="search_user_async"
                        :load-options="load_persons"
                        :placeholder="$t('components.searchUser')"
                        :normalizer="normalizer_persons"
                    />

                  </CCol>
                </CRow>

              </CCol>
              <CCol col="3">
                <CSelect
                    :options="[{label:$t('active'),value:39},{label:$t('deactivate'),value:40}]"
                    :label="$t('components.status')"
                         :value.sync="status_value"
                         :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                />
              </CCol>


              <CCol col="3">
                <CInput
                    :label="$t('components.summary')"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                    v-model="description"
                />
              </CCol>

            </CRow>
          </CCardBody>
        </CCard>
<!--        <CCard>-->
<!--          <CCardHeader>-->
<!--            <CRow>-->
<!--              <CCol col="8" style="text-align: start">-->
<!--                <strong>{{ $t('components.addCashier') }}</strong>-->
<!--              </CCol>-->
<!--              <CCol col="4" style="text-align: end">-->
<!--                <CButton v-if="status_form ==0" @click="insert_data(false)"-->
<!--                         type="submit" size="sm" color="secondary">-->
<!--                  {{ $t('buttons.submit') }}-->
<!--                </CButton>-->
<!--                <CButton v-if="status_form !=0" @click="insert_data(false)"-->
<!--                         type="submit" size="sm" color="secondary">-->
<!--                  {{ $t('buttons.edit') }}-->
<!--                </CButton>-->
<!--                <CButton-->
<!--                    class="mr-1"-->
<!--                    type="reset" size="sm" color="secondary">-->
<!--                  {{ $t("buttons.print") }}-->
<!--                </CButton>-->
<!--                <a :href="$route.fullPath" target="_blank">-->
<!--                  <CButton-->
<!--                      class="mr-1"-->
<!--                      size="sm"-->
<!--                      color="dark"-->
<!--                  >-->
<!--                    <CIcon size="sm" name="cil-plus"></CIcon>-->
<!--                  </CButton>-->
<!--                </a>-->

<!--              </CCol>-->
<!--            </CRow>-->
<!--          </CCardHeader>-->

<!--          <CCardBody>-->
<!--            <CRow>-->

<!--              <CCol sm="4">-->
<!--                <CRow form class="form-group">-->
<!--                  <CCol tag="label" sm="3" class="col-form-label">-->
<!--                    تنخواه گردان-->
<!--                  </CCol>-->
<!--                  <CCol sm="9">-->
<!--                    <treeselect-->
<!--                        v-model="document_person_tankhah"-->
<!--                        :options="searched_person"-->

<!--                        :async="search_user_async"-->
<!--                        :load-options="load_persons"-->
<!--                        :placeholder="$t('components.searchUser')"-->
<!--                        :normalizer="normalizer_persons"-->
<!--                    />-->

<!--                  </CCol>-->
<!--                </CRow>-->

<!--              </CCol>-->

<!--              <CCol col="4">-->
<!--                <CInput-->
<!--                    label="نام تنخواه"-->

<!--                    horizontal-->
<!--                    v-model="name_tankhah"-->

<!--                />-->
<!--              </CCol>-->

<!--              <CCol col="4">-->
<!--                <CInput-->
<!--                    :label="$t('components.summary')"-->
<!--                    horizontal-->
<!--                    v-model="description_tankhah"-->

<!--                />-->
<!--              </CCol>-->


<!--            </CRow>-->
<!--          </CCardBody>-->
<!--        </CCard>-->
      </CCol>
    </CRow>
    <CRow>
      <CCol md="12">
        <CCard>
<!--          <CCardHeader>-->
<!--            <strong>{{$t('sidebars.accountingList')}}</strong>-->
<!--          </CCardHeader>-->
          <CCardBody class="mb-3">
            <CRow>
              <CCol col="3">
                <CSelect :options="filtered_accounting_list" :label="$t('accountSarfasl')"
                         :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                         :value.sync="selected_cashier_type"

                />

              </CCol>
              <CCol col="3">
                <CSelect :options="[{label:$i18n.t('all'),value:0},{label:$i18n.t('active'),value:39},{label:$i18n.t('deactivate'),value:40}]"
                         :value.sync="filter_status"
                         :label="$t('tables.status')"
                         horizontal
                />
              </CCol>
            </CRow>

            <CDataTable
                :items="filtered_items"
                :fields="fields"
                striped
                column-filter
                border
                :items-per-page="20"
                hover
                sorter
                pagination
            >
              <template #row="{item,index}">

                <td style="text-align: center">
                  <p >{{ index + 1 }}</p>

                </td>

              </template>
              <template #summary="{item}">

                <td>
                  <p v-if="item.summary != 'null'">{{ item.summary }}</p>

                </td>

              </template>
 <template #boxCode="{item}">

                <td>
                  <p style="text-align: center;">{{ item.boxCode }}</p>

                </td>

              </template>
              <template #isActive="{item,index}">
                <td style="text-align: center">
                  <CIcon

                      v-if="item.isActive==39"
                      class="text-success" name="cil-check"/>
                  <CIcon

                      v-else
                      name="cil-check"/>
                </td>
              </template>

              <template #isCashier="{item}">

                <td>
                  <div>
                    {{ get_type(item) }}
                  </div>
                </td>

              </template>
              <template #operation="{item}">
                <td>
                  <CIcon @click.native="edit_item(item)" class="text-warning" name="cilPencil"/>
                  <CIcon @click.native="delete_item_dialog(item)" class="text-danger" name="cilTrash"/>
                </td>
              </template>


            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
// import the styles
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

var simulateAsync=null
const simulateAsyncOperation = fn => {
  if(simulateAsync!=null){
    clearTimeout(simulateAsync)
  }
  simulateAsync =  setTimeout(fn, 1000)
}
var items = [];


export default {
  name: 'Login',
  components: {
    Treeselect,

  },
  data() {
    return {
      filter_status:0,
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      status_value:39,
      validate_errors: [],
      name_tankhah: '',
      name: '',
      description_tankhah: '',
      description: '',
      selected_branch: '',
      selected_bank: '',
      cashier_no: '',
      sheba_no: '',
      selected_moein:0,
      branch_items: [],
      bank_items: [],
      searched_person: [],
      document_person: null,
      document_person_tankhah: null,
      search_user_async: true,
      load_persons({action, searchQuery, callback}) {

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            var url = "GetAllPersons";

            formData.append('IsVendor', false);
            formData.append('IsWorker', true);
            formData.append('IsCustomer', false);
            formData.append('IsActive', 0);

            axios.post(url, formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {
                  console.log(error);
                });
          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
        }
      },
      items: [],
      filtered_items: [],
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:3%'},
        {key: 'boxCode', label: this.$t('components.groupCode'), _style: 'width:10%'},

        {key: 'accountTitle', label: this.$t('accountSarfasl'), _style: 'width:10%'},
        {key: 'boxTitle', label: this.$t('tables.bankAccTitle'), _style: 'width:10%'},
        {key: 'userName', label: this.$t('components.userName'), _style: 'width:10%'},
        {key: 'branchName', label: this.$t('tables.branch'), _style: 'width:10%'},
        {key: 'isActive', label: this.$t('tables.status'), _style: 'width:10%'},
        // {key: 'isCashier', label: this.$t('tables.type'), _style: 'width:10%'},

        {key: 'summary', label: this.$t('tables.summary'), _style: 'width:10%'},
        {key: 'operation', label: this.$t('tables.operation'),sorter:false,filter:false, _style: 'width:5%;'},
      ],

      cashier_types: [
        {label: this.$t('all'), value: 0},
        {label: this.$t('components.cashier'), value: 1},
        {label: this.$t('components.salary'), value: 2}
      ],
      selected_cashier_type: 0,
      status_form: 0,
      all_accounting_list:[],
      filtered_accounting_list:[],
      filtered_accounting_list_add:[],

    }
  },
  created() {
  },
  mounted() {
    this.$root.root_validate_errors = [];

    this.get_bank();
    this.get_branches();
    this.get_lists();
    this.get_lists_groups();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'filter_status':function (){
      this.get_lists()
    },
    'selected_cashier_type': function () {
      if (this.selected_cashier_type == 0) {
        this.filtered_items = this.items;
      }
      else {
        this.filtered_items = this.items.filter(item => item.accountId == this.selected_cashier_type);
      }
    },

  },
  methods: {
    validateForm: function () {
      this.$root.root_validate_errors = [];
      return true;

      if (this.selected_branch != 0 && this.document_person != null
          && this.cashier_no != '' && this.name != '') {
        return true;
      }


      if (this.selected_branch == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectBranch'));
      }
      if (this.document_person == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectUser'));
      }
      if (this.cashier_no == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertCashierNo'));
      }
      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertCashierName'));
      }

      return false;
      // e.preventDefault();
    },

    get_type(item) {
      if (item.isCashier) {
        return this.$t('components.cashier')
      } else {
        return this.$t('components.salary')

      }

    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
    if(item.isCashier){
      this.name = item.boxTitle;
      this.description = item.summary;
      this.document_person = item.userId;

    }else{
      this.name_tankhah = item.boxTitle;
      this.description_tankhah = item.summary;
      this.document_person_tankhah = item.userId;

    }
      this.search_user_async = false;
this.status_value = item.isActive
      this.selected_branch = item.branchId;
      this.selected_bank = item.methodColor;
      this.cashier_no = item.boxCode;
      this.sheba_no = item.methodColor;

      this.searched_person = [{
        userId: item.userId,
        userName: item.userName,
        personCode : '',
        surName : '',
        mobileNo : '',
      }];
      var self = this;
      this.search_user_async = false;
      this.table_clicks_timer = setTimeout(() => {
        // this.result.push(event.type);
        self.search_user_async = true;
      }, 500);
      this.status_form = item.id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;
      this.search_user_async = true;
      this.document_person = null;
      this.name = null;
      this.description = null;
      this.selected_branch = null;
      this.selected_bank = null;
      this.cashier_no = null;
      this.sheba_no = null;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_lists() {
      var self = this;

      const formData = new FormData();


      formData.append('StatusId', this.filter_status);

      axios.post('GetCashierTitles', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.filtered_items = self.items;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_bank() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBanks', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.bank_items = [];
          self.bank_items = self.sort_array(
                  self.bank_items, content_data.data,
                  'id','bankTitle');


          self.selected_bank = self.bank_items[0].value
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_branches() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBranchList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.branch_items = [];
          self.branch_items = self.sort_array(
                  self.branch_items, content_data.data,
                  'branchId','branchTitle');


          self.selected_branch = self.branch_items[0].value

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    goToMembers(item) {

      this.$router.push({path: '/dashboard/accounting/sale-method-members/' + item.id});

    },

    insert_data(type) {

      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddCashierTitle";
      } else {
        url = "EditCashierTitle";
        formData.append('Id', this.status_form)

      }
      if (!type) {
        formData.append('BoxTitle', this.name_tankhah);
        formData.append('Summary', this.description_tankhah);
        formData.append('UserId', this.document_person_tankhah);

      } else {
        formData.append('BoxTitle', this.name);
        formData.append('Summary', this.description);
        formData.append('UserId', this.document_person);

      }
      formData.append('IsActive', this.status_value);

      // formData.append('BoxCode', this.cashier_no);
      // formData.append('BranchId', this.selected_branch);
      formData.append('IsCashier', type);
      formData.append('AccountId', self.selected_moein);

      // formData.append('AreaId', this.selected_area);
      axios.post(url, formData, {}).then((res) => {

        self.status_form = 0;
        self.name = '';
        self.name_tankhah = '';
        self.bank_no = '';
        self.description = '';
        self.description_tankhah = '';
        self.get_lists();
        self.search_user_async = true;
        self.document_person = null;
        self.document_person_tankhah = null;
        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {

      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessageParams", [item.boxTitle]), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteCashierTitle";
      formData.append('Id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    get_lists_groups() {
      var self = this;
      self.items_parent = [];
      self.data_with_children = []

      const formData = new FormData();
      var url = "Get_AllAccountingGroups";
      // formData.append("MasterId", 0);

      // formData.append("id", 1);
      this.filtered_accounting_list=[{label:this.$t('all'),value:0}]
      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {


              self.all_accounting_list = response.data.data


              // console.log(self.data);
              response.data.data.forEach((val) => {
                if (val.parentId == 10) {

                  var obj = {
                    label: val.accountName,
                    name_code: val.accountName + " (" + val.accountCode + ")",
                    nature: val.nature,
                    type: val.type,
                    code: val.accountCode,
                    parentId: val.parentId,
                    value: val.id,
                    // children: self.get_childrens(val.id, response.data.data)


                  }
                  // self.get_childrens_one_sub(val.id, self.data).forEach((val2) => {
                  //   var obj2 = {
                  //     label: val2.label,
                  //     code: val2.accountCode,
                  //     value: val2.value,
                  //   }
                  //   self.items_parent.push(obj2)
                  //
                  // });
                  self.filtered_accounting_list.push(obj);
                  self.filtered_accounting_list_add.push(obj);


                }
              });
              self.selected_moein = self.filtered_accounting_list_add[0].value

              // self.filter_data()
            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },

  }
}

</script>
